import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const API_URL = '/api.php';

const Icons = {
  Dashboard: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" /></svg>,
  Car: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h8m-8 4h8m-8 4h8M4 3h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1z" /></svg>,
  Message: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>,
  Add: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>,
  Edit: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" /></svg>,
  Delete: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>,
  Star: () => <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" /></svg>,
  Logout: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>,
  Close: () => <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>,
  ArrowRight: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>,
  Check: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>,
  Eye: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>,
  Menu: () => <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>,
  Mail: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>,
  Phone: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>,
  Calendar: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
};

const AdminDashboard = () => {
  const { user, token, logout, loading: authLoading, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [cars, setCars] = useState([]);
  const [hiddenCars, setHiddenCars] = useState([]);
  const [stats, setStats] = useState({ total_cars: 0, featured_cars: 0, deleted_cars: 0 });
  const [showModal, setShowModal] = useState(false);
  const [editingCar, setEditingCar] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showHidden, setShowHidden] = useState(false);
  const [carFilter, setCarFilter] = useState('all'); // all, visible, hidden, featured
  const [formData, setFormData] = useState({
    name: '',
    image: '',
    transmission: 'Automatic',
    fuel_type: 'Petrol',
    seating_capacity: 5,
    location: 'Udaipur, Rajasthan',
    price_per_day: '',
    description: '',
    features: '',
    is_featured: 0
  });
  
  // Messages state
  const [messages, setMessages] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [messageFilter, setMessageFilter] = useState('all'); // all, unread, read
  const [messagesLoading, setMessagesLoading] = useState(false);
  const [messagesError, setMessagesError] = useState(null);

  // Redirect if not authenticated
  useEffect(() => {
    if (!authLoading && !isAuthenticated) {
      navigate('/admin/login');
    }
  }, [authLoading, isAuthenticated, navigate]);

  useEffect(() => {
    if (isAuthenticated) {
      fetchData();
    }
  }, [isAuthenticated]);

  // Fetch messages when messages tab is active
  useEffect(() => {
    if (isAuthenticated && activeTab === 'messages') {
      fetchMessages();
    }
  }, [isAuthenticated, activeTab]);

  const fetchData = async () => {
    if (!token) return;
    setLoading(true);
    try {
      const [carsRes, statsRes, hiddenCarsRes, unreadRes] = await Promise.all([
        fetch(`${API_URL}?action=cars`, { headers: { 'Authorization': `Bearer ${token}` } }),
        fetch(`${API_URL}?action=stats`, { headers: { 'Authorization': `Bearer ${token}` } }),
        fetch(`${API_URL}?action=hidden-cars`, { headers: { 'Authorization': `Bearer ${token}` } }),
        fetch(`${API_URL}?action=contact-unread-count`, { headers: { 'Authorization': `Bearer ${token}` } })
      ]);
      
      const carsData = await carsRes.json();
      const statsData = await statsRes.json();
      const hiddenCarsData = await hiddenCarsRes.json();
      const unreadData = await unreadRes.json();
      
      if (carsData.success) setCars(carsData.data);
      if (statsData.success) setStats(statsData.data);
      if (hiddenCarsData.success) setHiddenCars(hiddenCarsData.data || []);
      if (unreadData.success) setUnreadCount(unreadData.data.unread_count || 0);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
    setLoading(false);
  };

  // Fetch messages
  const fetchMessages = async () => {
    if (!token) return;
    setMessagesLoading(true);
    setMessagesError(null);
    try {
      const [messagesRes, unreadRes] = await Promise.all([
        fetch(`${API_URL}?action=contact-messages`, { headers: { 'Authorization': `Bearer ${token}` } }),
        fetch(`${API_URL}?action=contact-unread-count`, { headers: { 'Authorization': `Bearer ${token}` } })
      ]);
      
      const messagesData = await messagesRes.json();
      const unreadData = await unreadRes.json();
      
      console.log('Messages API Response:', messagesData);
      console.log('Unread API Response:', unreadData);
      
      if (messagesData.success) {
        console.log('Messages data.messages:', messagesData.data.messages);
        console.log('Setting messages state with:', messagesData.data.messages);
        setMessages(messagesData.data.messages || []);
      } else {
        setMessagesError(messagesData.error || 'Failed to fetch messages');
        console.error('Messages API Error:', messagesData.error);
      }
      
      if (unreadData.success) {
        setUnreadCount(unreadData.data.unread_count || 0);
      }
    } catch (error) {
      console.error('Failed to fetch messages:', error);
      setMessagesError(error.message || 'Network error. Please check your connection.');
    }
    setMessagesLoading(false);
  };

  // Mark message as read
  const markAsRead = async (id) => {
    if (!token) return;
    try {
      const response = await fetch(`${API_URL}?action=contact-mark-read`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ id })
      });
      
      const data = await response.json();
      if (data.success) {
        fetchMessages();
      }
    } catch (error) {
      console.error('Failed to mark message as read:', error);
    }
  };

  // Delete message
  const deleteMessage = async (id) => {
    if (!window.confirm('Are you sure you want to delete this message?')) return;
    if (!token) return;
    try {
      const response = await fetch(`${API_URL}?action=contact-delete`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ id })
      });
      
      const data = await response.json();
      if (data.success) {
        fetchMessages();
      }
    } catch (error) {
      console.error('Failed to delete message:', error);
    }
  };

  // View full message
  const viewMessage = (message) => {
    setSelectedMessage(message);
    setShowMessageModal(true);
    // Mark as read when viewing
    if (!message.is_read) {
      markAsRead(message.id);
    }
  };

  // Format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Truncate text
  const truncateText = (text, maxLength = 50) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  if (!isAuthenticated) {
    return null;
  }

  const openAddModal = () => {
    setFormData({
      name: '',
      image: '',
      transmission: 'Automatic',
      fuel_type: 'Petrol',
      seating_capacity: 5,
      location: 'Udaipur, Rajasthan',
      price_per_day: '',
      description: '',
      features: '',
      is_featured: 0
    });
    setShowModal(true);
  };

  const openEditModal = (car) => {
    setEditingCar(car);
    setFormData({
      name: car.name,
      image: car.image,
      transmission: car.transmission,
      fuel_type: car.fuel_type,
      seating_capacity: car.seating_capacity,
      location: car.location,
      price_per_day: car.price_per_day,
      description: car.description,
      features: car.features,
      is_featured: car.is_featured
    });
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Use car-update for edit, car-create for new
    const action = editingCar ? `car-update&id=${editingCar.id}` : 'car-create';
    console.log('Submitting form with action:', action);
    console.log('Form data:', formData);
    
    try {
      const response = await fetch(`${API_URL}?action=${action}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(formData)
      });
      
      const data = await response.json();
      console.log('Submit response:', data);
      
      if (data.success) {
        setShowModal(false);
        fetchData();
        alert(data.message || 'Car saved successfully!');
      } else {
        alert(data.message || data.error || 'Operation failed');
      }
    } catch (error) {
      console.error('Save failed:', error);
      alert('Failed to save car: ' + error.message);
    }
  };

  const toggleFeatured = async (car) => {
    try {
      const response = await fetch(`${API_URL}?action=car-toggle-featured&id=${car.id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ is_featured: car.is_featured ? 0 : 1 })
      });
      
      const data = await response.json();
      if (data.success) {
        fetchData();
      }
    } catch (error) {
      console.error('Toggle failed:', error);
    }
  };

  const toggleVisibility = async (car) => {
    console.log('Toggle visibility called for car:', car.id, 'Current status:', car.is_active);
    console.log('Token:', token ? 'present' : 'missing');
    
    try {
      const response = await fetch(`${API_URL}?action=toggle-visibility&id=${car.id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      
      const data = await response.json();
      console.log('Toggle visibility response:', data);
      console.log('Response status:', response.status);
      
      if (data.success) {
        fetchData();
        alert(data.message);
      } else {
        alert(data.message || data.error || 'Failed to toggle visibility');
      }
    } catch (error) {
      console.error('Toggle visibility failed:', error);
      alert('Error: ' + error.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this car?')) return;
    console.log('Delete car called with id:', id);
    console.log('Token:', token ? 'present' : 'missing');
    
    try {
      const response = await fetch(`${API_URL}?action=delete-car&id=${id}`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` 
        }
      });
      
      const data = await response.json();
      console.log('Delete response:', data);
      console.log('Response status:', response.status);
      
      if (data.success) {
        fetchData();
        alert('Car deleted successfully!');
      } else {
        alert(data.message || data.error || 'Delete failed');
      }
    } catch (error) {
      console.error('Delete failed:', error);
      alert('Error: ' + error.message);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#0a0a0a] via-[#0d0d0d] to-[#1a1a1a] flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-[#c9a962]/20 border-t-[#c9a962] rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-[#c9a962] text-xl font-semibold animate-pulse">Loading Dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-gradient-to-br from-[#0a0a0a] via-[#0d0d0d] to-[#1a1a1a]">
      {/* Mobile Overlay with blur */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/70 backdrop-blur-sm z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside className={`
        fixed lg:relative inset-y-0 left-0 z-50
        w-72 bg-gradient-to-b from-[#1a1a1a] to-[#0d0d0d] border-r border-gray-800
        transform transition-transform duration-300 ease-out
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0
        shadow-2xl lg:shadow-none
      `}>
        {/* Sidebar Header with Logo */}
        <div className="h-full flex flex-col">
          <div className="p-4 lg:p-6">
          <div className="flex items-center justify-between mb-6 lg:mb-8">
            <div className="flex items-center gap-3">
              <img src="/logo.jpg" alt="Brothers Car Rental" className="w-12 h-12 lg:w-14 lg:h-14 rounded-xl object-cover shadow-lg border-2 border-[#c9a962]/30" />
              <div>
                <span className="text-white font-bold text-xl">Brothers</span>
                <span className="text-[#c9a962] font-bold text-xl block">Car</span>
                <p className="text-gray-500 text-xs">Rental Admin</p>
              </div>
            </div>
            <button 
              onClick={() => setSidebarOpen(false)}
              className="lg:hidden text-gray-400 hover:text-white p-2 hover:bg-gray-800 rounded-lg transition-colors"
            >
              <Icons.Close />
            </button>
          </div>
          
          {/* Navigation with improved styling */}
          <nav className="space-y-2 px-2">
            <button
              onClick={() => { setActiveTab('dashboard'); setSidebarOpen(false); }}
              className={`w-full flex items-center gap-3 px-4 py-3.5 rounded-xl transition-all duration-200 ${activeTab === 'dashboard' ? 'bg-gradient-to-r from-[#c9a962]/20 to-[#c9a962]/10 text-[#c9a962] border border-[#c9a962]/30' : 'text-gray-300 hover:text-white hover:bg-gray-800/50'}`}
            >
              <Icons.Dashboard />
              <span className="font-medium">Dashboard</span>
              {activeTab === 'dashboard' && (
                <span className="ml-auto w-2 h-2 bg-[#c9a962] rounded-full"></span>
              )}
            </button>
            <button
              onClick={() => { setActiveTab('cars'); setSidebarOpen(false); }}
              className={`w-full flex items-center gap-3 px-4 py-3.5 rounded-xl transition-all duration-200 ${activeTab === 'cars' ? 'bg-gradient-to-r from-[#c9a962]/20 to-[#c9a962]/10 text-[#c9a962] border border-[#c9a962]/30' : 'text-gray-300 hover:text-white hover:bg-gray-800/50'}`}
            >
              <Icons.Car />
              <span className="font-medium">Cars</span>
              {activeTab === 'cars' && (
                <span className="ml-auto w-2 h-2 bg-[#c9a962] rounded-full"></span>
              )}
            </button>
            <button
              onClick={() => { setActiveTab('messages'); setSidebarOpen(false); }}
              className={`w-full flex items-center gap-3 px-4 py-3.5 rounded-xl transition-all duration-200 relative ${activeTab === 'messages' ? 'bg-gradient-to-r from-[#c9a962]/20 to-[#c9a962]/10 text-[#c9a962] border border-[#c9a962]/30' : 'text-gray-300 hover:text-white hover:bg-gray-800/50'}`}
            >
              <Icons.Message />
              <span className="font-medium">Messages</span>
              {unreadCount > 0 && (
                <span className="ml-auto bg-gradient-to-r from-red-500 to-red-600 text-white text-xs px-2.5 py-1 rounded-full font-semibold shadow-lg">
                  {unreadCount}
                </span>
              )}
              {activeTab === 'messages' && !unreadCount && (
                <span className="ml-auto w-2 h-2 bg-[#c9a962] rounded-full"></span>
              )}
            </button>
          </nav>
          </div>
        </div>
        
        {/* Sidebar Footer with User Info */}
        <div className="mt-auto p-4 lg:p-6 border-t border-gray-800 bg-[#0d0d0d]/50">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 bg-gradient-to-br from-[#c9a962] to-[#a08040] rounded-xl flex items-center justify-center text-black font-bold flex-shrink-0 shadow-lg">
              {user?.username?.[0]?.toUpperCase()}
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-white font-semibold truncate">{user?.username}</p>
              <p className="text-gray-500 text-xs">Administrator</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-3 text-red-400 hover:bg-red-500/10 rounded-xl transition-colors group"
          >
            <Icons.Logout />
            <span className="font-medium group-hover:text-red-300">Logout</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 p-4 lg:p-8 overflow-x-hidden">
        {/* Header */}
        <header className="flex items-center justify-between mb-6 lg:mb-8 gap-4">
          <div className="flex items-center gap-3">
            <button 
              onClick={() => setSidebarOpen(true)}
              className="lg:hidden text-white p-2.5 hover:bg-gray-800 rounded-xl transition-colors bg-gray-800/50"
            >
              <Icons.Menu />
            </button>
            <div className="bg-gradient-to-r from-[#c9a962]/20 to-transparent px-4 py-2 rounded-xl border border-[#c9a962]/20">
              <h1 className="text-xl lg:text-2xl font-bold text-white">
                {activeTab === 'dashboard' ? 'Dashboard' : activeTab === 'cars' ? 'Car Management' : 'Messages'}
              </h1>
              <p className="text-gray-400 text-sm">Welcome back, <span className="text-[#c9a962]">{user?.username}</span></p>
            </div>
          </div>
          {activeTab !== 'messages' && (
            <button
              onClick={openAddModal}
              className="flex items-center gap-2 px-4 lg:px-6 py-2.5 lg:py-3 bg-gradient-to-r from-[#c9a962] to-[#a08040] text-black font-semibold rounded-xl hover:shadow-xl hover:shadow-[#c9a962]/30 transition-all text-sm lg:text-base"
            >
              <Icons.Add />
              <span className="hidden sm:inline">Add New Car</span>
              <span className="sm:hidden">Add</span>
            </button>
          )}
        </header>

        {/* Dashboard Stats */}
        {activeTab === 'dashboard' && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6 mb-6 lg:mb-8">
            <div className="group bg-gradient-to-br from-[#1a1a1a] to-[#0d0d0d] rounded-2xl p-5 lg:p-6 border border-gray-800 hover:border-blue-500/50 transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/10">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-gray-400 text-sm lg:text-base font-medium">Total Cars</h3>
                <div className="w-12 h-12 lg:w-14 lg:h-14 bg-gradient-to-br from-blue-500/20 to-blue-600/10 rounded-xl flex items-center justify-center text-blue-400 group-hover:scale-110 transition-transform">
                  <Icons.Car />
                </div>
              </div>
              <p className="text-3xl lg:text-4xl font-bold text-white">{stats.total_cars}</p>
              <p className="text-gray-500 text-sm mt-2">Available for rent</p>
            </div>
            <div className="group bg-gradient-to-br from-[#1a1a1a] to-[#0d0d0d] rounded-2xl p-5 lg:p-6 border border-gray-800 hover:border-[#c9a962]/50 transition-all duration-300 hover:shadow-xl hover:shadow-[#c9a962]/10 cursor-pointer" onClick={() => setActiveTab('cars')}>
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-gray-400 text-sm lg:text-base font-medium">Featured Cars</h3>
                <div className="w-12 h-12 lg:w-14 lg:h-14 bg-gradient-to-br from-[#c9a962]/20 to-[#a08040]/10 rounded-xl flex items-center justify-center text-[#c9a962] group-hover:scale-110 transition-transform">
                  <Icons.Star />
                </div>
              </div>
              <p className="text-3xl lg:text-4xl font-bold text-white">{stats.featured_cars}</p>
              <p className="text-gray-500 text-sm mt-2">Premium listings</p>
            </div>
            <div className="group bg-gradient-to-br from-[#1a1a1a] to-[#0d0d0d] rounded-2xl p-5 lg:p-6 border border-gray-800 hover:border-purple-500/50 transition-all duration-300 hover:shadow-xl hover:shadow-purple-500/10 cursor-pointer" onClick={() => setActiveTab('messages')}>
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-gray-400 text-sm lg:text-base font-medium">Unread Messages</h3>
                <div className="w-12 h-12 lg:w-14 lg:h-14 bg-gradient-to-br from-purple-500/20 to-purple-600/10 rounded-xl flex items-center justify-center text-purple-400 group-hover:scale-110 transition-transform">
                  <Icons.Message />
                </div>
              </div>
              <p className="text-3xl lg:text-4xl font-bold text-white">{unreadCount}</p>
              <p className="text-gray-500 text-sm mt-2">
                {unreadCount === 0 ? 'All caught up!' : 'New inquiries'}
              </p>
            </div>
          </div>
        )}

        {/* Cars Table - Amazing Design */}
        {activeTab === 'cars' && (
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0d0d0d] rounded-2xl border border-gray-800 overflow-hidden shadow-2xl">
            {/* Horizontal Filter Navbar */}
            <div className="flex items-center gap-3 p-4 lg:p-5 bg-gradient-to-r from-[#0d0d0d] to-[#1a1a1a] border-b border-gray-800 overflow-x-auto">
              <div className="flex items-center gap-2 bg-gray-800/50 p-1 rounded-xl flex-nowrap">
                <button
                  onClick={() => { setCarFilter('all'); setShowHidden(false); }}
                  className={`px-4 py-2 rounded-lg whitespace-nowrap transition-all duration-200 text-sm font-medium ${carFilter === 'all' ? 'bg-gradient-to-r from-[#c9a962] to-[#a08040] text-black shadow-lg' : 'bg-gray-800 text-gray-400 hover:text-white'}`}
                >
                  All ({cars.length})
                </button>
                <button
                  onClick={() => { setCarFilter('featured'); setShowHidden(false); }}
                  className={`px-4 py-2 rounded-lg whitespace-nowrap transition-all duration-200 text-sm font-medium ${carFilter === 'featured' ? 'bg-gradient-to-r from-[#c9a962] to-[#a08040] text-black shadow-lg' : 'bg-gray-800 text-gray-400 hover:text-white'}`}
                >
                  Featured ({cars.filter(c => c.is_featured).length})
                </button>
                <button
                  onClick={() => { setCarFilter('visible'); setShowHidden(false); }}
                  className={`px-4 py-2 rounded-lg whitespace-nowrap transition-all duration-200 text-sm font-medium ${carFilter === 'visible' ? 'bg-gradient-to-r from-[#c9a962] to-[#a08040] text-black shadow-lg' : 'bg-gray-800 text-gray-400 hover:text-white'}`}
                >
                  Visible ({cars.length})
                </button>
                <button
                  onClick={() => { setCarFilter('hidden'); setShowHidden(true); }}
                  className={`px-4 py-2 rounded-lg whitespace-nowrap transition-all duration-200 text-sm font-medium ${carFilter === 'hidden' ? 'bg-red-500/20 text-red-400 border border-red-500/30' : 'bg-gray-800 text-gray-400 hover:text-white'}`}
                >
                  Hidden ({hiddenCars.length})
                </button>
              </div>
              <button
                onClick={() => setShowHidden(!showHidden)}
                className={`px-4 py-2 rounded-xl whitespace-nowrap transition-all duration-200 text-sm font-medium flex items-center gap-2 ${showHidden ? 'bg-[#c9a962]/20 text-[#c9a962] border border-[#c9a962]/30' : 'bg-gray-800/50 text-gray-400 hover:text-white'}`}
              >
                {showHidden ? <Icons.Check /> : null}
                {showHidden ? 'Showing' : 'Show Hidden'}
              </button>
            </div>
            
            {/* Table Container - Scrollable on Mobile */}
            <div className="overflow-x-auto">
            <table className="w-full min-w-[700px]">
              <thead className="bg-[#0d0d0d]">
                <tr>
                  <th className="text-left px-4 lg:px-6 py-3 lg:py-4 text-white font-medium text-sm">Car</th>
                  <th className="text-left px-4 lg:px-6 py-3 lg:py-4 text-white font-medium text-sm">Status</th>
                  <th className="text-left px-4 lg:px-6 py-3 lg:py-4 text-white font-medium text-sm">Transmission</th>
                  <th className="text-left px-4 lg:px-6 py-3 lg:py-4 text-white font-medium text-sm">Fuel</th>
                  <th className="text-left px-4 lg:px-6 py-3 lg:py-4 text-white font-medium text-sm">Seats</th>
                  <th className="text-left px-4 lg:px-6 py-3 lg:py-4 text-white font-medium text-sm">Price/Day</th>
                  <th className="text-left px-4 lg:px-6 py-3 lg:py-4 text-white font-medium text-sm">Featured</th>
                  <th className="text-left px-4 lg:px-6 py-3 lg:py-4 text-white font-medium text-sm">Actions</th>
                </tr>
              </thead>
              <tbody>
                {/* Visible Cars */}
                {carFilter !== 'hidden' && cars
                  .filter(car => carFilter === 'all' || carFilter === 'visible' || (carFilter === 'featured' && car.is_featured))
                  .map((car) => (
                  <tr key={car.id} className="border-t border-gray-800 hover:bg-gray-800/50">
                    <td className="px-4 lg:px-6 py-3 lg:py-4">
                      <div className="flex items-center gap-3 lg:gap-4">
                        <img src={car.image} alt={car.name} className="w-12 h-10 lg:w-16 lg:h-12 object-cover rounded-lg flex-shrink-0" />
                        <div className="min-w-0">
                          <p className="text-white font-medium truncate max-w-[120px] lg:max-w-none">{car.name}</p>
                          <p className="text-white text-sm hidden sm:block">{car.location}</p>
                        </div>
                      </div>
                    </td>
                    <td className="px-4 lg:px-6 py-3 lg:py-4">
                      <span className="px-2 py-1 bg-green-500/20 text-green-400 text-xs rounded-full">Visible</span>
                    </td>
                    <td className="px-4 lg:px-6 py-3 lg:py-4 text-white text-sm">{car.transmission}</td>
                    <td className="px-4 lg:px-6 py-3 lg:py-4 text-white text-sm">{car.fuel_type}</td>
                    <td className="px-4 lg:px-6 py-3 lg:py-4 text-white text-sm">{car.seating_capacity}</td>
                    <td className="px-4 lg:px-6 py-3 lg:py-4 text-[#c9a962] font-semibold text-sm">₹{Number(car.price_per_day).toLocaleString()}</td>
                    <td className="px-4 lg:px-6 py-3 lg:py-4">
                      <button
                        onClick={() => toggleFeatured(car)}
                        className={`p-2 rounded-lg transition-colors ${car.is_featured ? 'bg-[#c9a962]/20 text-[#c9a962]' : 'bg-gray-800 text-white'}`}
                      >
                        <Icons.Star />
                      </button>
                    </td>
                    <td className="px-4 lg:px-6 py-3 lg:py-4">
                      <div className="flex items-center gap-1 lg:gap-2">
                        <button
                          onClick={() => toggleVisibility(car)}
                          className="p-2 bg-yellow-500/20 text-yellow-400 rounded-lg hover:bg-yellow-500/30 transition-colors"
                          title="Hide Car"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                        </button>
                        <button
                          onClick={() => openEditModal(car)}
                          className="p-2 bg-blue-500/20 text-blue-400 rounded-lg hover:bg-blue-500/30 transition-colors"
                        >
                          <Icons.Edit />
                        </button>
                        <button
                          onClick={() => handleDelete(car.id)}
                          className="p-2 bg-red-500/20 text-red-400 rounded-lg hover:bg-red-500/30 transition-colors"
                        >
                          <Icons.Delete />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {/* Hidden Cars */}
                {(carFilter === 'hidden' || showHidden) && hiddenCars.map((car) => (
                  <tr key={car.id} className="border-t border-gray-800 hover:bg-gray-800/50 bg-gray-900/50">
                    <td className="px-4 lg:px-6 py-3 lg:py-4">
                      <div className="flex items-center gap-3 lg:gap-4">
                        <img src={car.image} alt={car.name} className="w-12 h-10 lg:w-16 lg:h-12 object-cover rounded-lg opacity-50 flex-shrink-0" />
                        <div className="min-w-0">
                          <p className="text-white font-medium truncate max-w-[120px] lg:max-w-none">{car.name}</p>
                          <p className="text-white text-sm hidden sm:block">{car.location}</p>
                        </div>
                      </div>
                    </td>
                    <td className="px-4 lg:px-6 py-3 lg:py-4">
                      <span className="px-2 py-1 bg-gray-500/20 text-gray-400 text-xs rounded-full">Hidden</span>
                    </td>
                    <td className="px-4 lg:px-6 py-3 lg:py-4 text-white text-sm">{car.transmission}</td>
                    <td className="px-4 lg:px-6 py-3 lg:py-4 text-white text-sm">{car.fuel_type}</td>
                    <td className="px-4 lg:px-6 py-3 lg:py-4 text-white text-sm">{car.seating_capacity}</td>
                    <td className="px-4 lg:px-6 py-3 lg:py-4 text-white text-sm">₹{Number(car.price_per_day).toLocaleString()}</td>
                    <td className="px-4 lg:px-6 py-3 lg:py-4">
                      <button
                        onClick={() => toggleFeatured(car)}
                        className={`p-2 rounded-lg transition-colors ${car.is_featured ? 'bg-[#c9a962]/20 text-[#c9a962]' : 'bg-gray-800 text-white'}`}
                      >
                        <Icons.Star />
                      </button>
                    </td>
                    <td className="px-4 lg:px-6 py-3 lg:py-4">
                      <div className="flex items-center gap-1 lg:gap-2">
                        <button
                          onClick={() => toggleVisibility(car)}
                          className="p-2 bg-green-500/20 text-green-400 rounded-lg hover:bg-green-500/30 transition-colors"
                          title="Show Car"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                        </button>
                        <button
                          onClick={() => openEditModal(car)}
                          className="p-2 bg-blue-500/20 text-blue-400 rounded-lg hover:bg-blue-500/30 transition-colors"
                        >
                          <Icons.Edit />
                        </button>
                        <button
                          onClick={() => handleDelete(car.id)}
                          className="p-2 bg-red-500/20 text-red-400 rounded-lg hover:bg-red-500/30 transition-colors"
                        >
                          <Icons.Delete />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </div>
        )}
        
        {/* Messages Section - Amazing UI */}
        {activeTab === 'messages' && (
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0d0d0d] rounded-2xl border border-gray-800 overflow-hidden shadow-2xl">
            {/* Filter Navbar with amazing design */}
            <div className="flex items-center gap-3 p-4 lg:p-5 bg-gradient-to-r from-[#0d0d0d] to-[#1a1a1a] border-b border-gray-800">
              <div className="flex items-center gap-2 bg-gray-800/50 p-1 rounded-xl">
                <button
                  onClick={() => setMessageFilter('all')}
                  className={`px-4 py-2 rounded-lg whitespace-nowrap transition-all duration-200 text-sm font-medium ${messageFilter === 'all' ? 'bg-gradient-to-r from-[#c9a962] to-[#a08040] text-black shadow-lg' : 'text-gray-400 hover:text-white'}`}
                >
                  All ({messages.length})
                </button>
                <button
                  onClick={() => setMessageFilter('unread')}
                  className={`px-4 py-2 rounded-lg whitespace-nowrap transition-all duration-200 text-sm font-medium flex items-center gap-2 ${messageFilter === 'unread' ? 'bg-gradient-to-r from-[#c9a962] to-[#a08040] text-black shadow-lg' : 'text-gray-400 hover:text-white'}`}
                >
                  <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
                  Unread ({messages.filter(m => !m.is_read).length})
                </button>
                <button
                  onClick={() => setMessageFilter('read')}
                  className={`px-4 py-2 rounded-lg whitespace-nowrap transition-all duration-200 text-sm font-medium ${messageFilter === 'read' ? 'bg-gradient-to-r from-[#c9a962] to-[#a08040] text-black shadow-lg' : 'text-gray-400 hover:text-white'}`}
                >
                  Read ({messages.filter(m => m.is_read).length})
                </button>
              </div>
              <div className="ml-auto text-gray-500 text-sm hidden sm:block">
                Click on a message to view details
              </div>
            </div>
            
            <div className="max-h-[calc(100vh-280px)] overflow-y-auto">
              {/* Loading State */}
              {messagesLoading && (
                <div className="p-12 text-center">
                  <div className="w-16 h-16 border-4 border-[#c9a962]/20 border-t-[#c9a962] rounded-full animate-spin mx-auto mb-4"></div>
                  <p className="text-[#c9a962] text-lg font-semibold">Loading messages...</p>
                </div>
              )}
              
              {/* Error State */}
              {!messagesLoading && messagesError && (
                <div className="p-12 text-center">
                  <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-10 h-10 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                  </div>
                  <p className="text-red-400 text-xl font-semibold mb-2">Error loading messages</p>
                  <p className="text-gray-500 mb-4">{messagesError}</p>
                  <button
                    onClick={fetchMessages}
                    className="px-6 py-2 bg-[#c9a962] text-black font-semibold rounded-xl hover:bg-[#a08040] transition-colors"
                  >
                    Try Again
                  </button>
                </div>
              )}
              
              {/* Empty State */}
              {!messagesLoading && !messagesError && messages.length === 0 ? (
                <div className="p-12 text-center">
                  <div className="w-20 h-20 bg-gray-800/50 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icons.Mail />
                  </div>
                  <p className="text-white text-xl font-semibold mb-2">No messages yet</p>
                  <p className="text-gray-500">Customer inquiries will appear here</p>
                </div>
              ) : null}
              
              {/* Messages List */}
              {!messagesLoading && !messagesError && messages.length > 0 && (
                <div className="divide-y divide-gray-800">
                  {messages
                    .filter(m => messageFilter === 'all' || (messageFilter === 'unread' && !m.is_read) || (messageFilter === 'read' && m.is_read))
                    .map((message, index) => (
                      <div 
                        key={message.id} 
                        onClick={() => viewMessage(message)}
                        className={`p-4 lg:p-5 cursor-pointer transition-all duration-200 hover:bg-gray-800/30 ${!message.is_read ? 'bg-gradient-to-r from-blue-500/5 to-transparent border-l-4 border-l-blue-500' : ''}`}
                        style={{ animationDelay: `${index * 50}ms` }}
                      >
                        <div className="flex items-start gap-4">
                          {/* Avatar with gradient */}
                          <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-lg font-bold flex-shrink-0 shadow-lg ${!message.is_read ? 'bg-gradient-to-br from-[#c9a962] to-[#a08040] text-black' : 'bg-gray-800 text-gray-400'}`}>
                            {message.name?.[0]?.toUpperCase()}
                          </div>
                          
                          {/* Message Content */}
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 mb-1">
                              <h3 className={`font-semibold truncate ${!message.is_read ? 'text-white' : 'text-gray-300'}`}>
                                {message.name}
                              </h3>
                              {!message.is_read && (
                                <span className="px-2 py-0.5 bg-blue-500/20 text-blue-400 text-xs rounded-full flex items-center gap-1">
                                  <span className="w-1.5 h-1.5 bg-blue-400 rounded-full animate-pulse"></span>
                                  New
                                </span>
                              )}
                            </div>
                            
                            <div className="flex items-center gap-4 text-sm text-gray-500 mb-2">
                              <span className="flex items-center gap-1 text-[#c9a962] hover:underline">
                                <Icons.Phone />
                                {message.phone}
                              </span>
                              <span className="flex items-center gap-1">
                                <Icons.Calendar />
                                {formatDate(message.created_at)}
                              </span>
                            </div>
                            
                            <p className="text-gray-400 text-sm truncate pr-4">
                              {truncateText(message.message, 80)}
                            </p>
                          </div>
                          
                          {/* Action Buttons */}
                          <div className="flex items-center gap-2 flex-shrink-0" onClick={(e) => e.stopPropagation()}>
                            <button
                              onClick={() => viewMessage(message)}
                              className="p-2.5 bg-[#c9a962]/20 text-[#c9a962] rounded-xl hover:bg-[#c9a962]/30 transition-colors"
                              title="View Full Message"
                            >
                              <Icons.Eye />
                            </button>
                            {!message.is_read && (
                              <button
                                onClick={() => markAsRead(message.id)}
                                className="p-2.5 bg-green-500/20 text-green-400 rounded-xl hover:bg-green-500/30 transition-colors"
                                title="Mark as Read"
                              >
                                <Icons.Check />
                              </button>
                            )}
                            <button
                              onClick={() => deleteMessage(message.id)}
                              className="p-2.5 bg-red-500/20 text-red-400 rounded-xl hover:bg-red-500/30 transition-colors"
                              title="Delete"
                            >
                              <Icons.Delete />
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>
          </div>
        )}
      </main>

      {/* Add/Edit Modal - Amazing Design */}
      {showModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0d0d0d] rounded-2xl w-full max-w-2xl border border-gray-800 max-h-[90vh] overflow-y-auto shadow-2xl">
            <div className="flex items-center justify-between p-5 lg:p-6 border-b border-gray-800 bg-gradient-to-r from-[#0d0d0d] to-[#1a1a1a] rounded-t-2xl">
              <h2 className="text-xl lg:text-2xl font-bold text-white">
                {editingCar ? 'Edit Car' : 'Add New Car'}
              </h2>
              <button onClick={() => setShowModal(false)} className="text-gray-400 hover:text-white p-2 hover:bg-gray-800 rounded-xl transition-colors">
                <Icons.Close />
              </button>
            </div>
            
            <form onSubmit={handleSubmit} className="p-5 lg:p-6 space-y-5">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-300 mb-2">Car Name</label>
                  <input
                    type="text"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    className="w-full px-4 py-3 bg-[#0d0d0d] border border-gray-700 rounded-xl text-white focus:border-[#c9a962] focus:ring-1 focus:ring-[#c9a962] transition-colors"
                    required
                  />
                </div>
                
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-300 mb-2">Image URL</label>
                  <input
                    type="url"
                    value={formData.image}
                    onChange={(e) => setFormData({...formData, image: e.target.value})}
                    className="w-full px-4 py-3 bg-[#0d0d0d] border border-gray-700 rounded-xl text-white focus:border-[#c9a962] focus:ring-1 focus:ring-[#c9a962] transition-colors"
                    required
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">Transmission</label>
                  <select
                    value={formData.transmission}
                    onChange={(e) => setFormData({...formData, transmission: e.target.value})}
                    className="w-full px-4 py-3 bg-[#0d0d0d] border border-gray-700 rounded-xl text-white focus:border-[#c9a962] transition-colors"
                  >
                    <option value="Automatic">Automatic</option>
                    <option value="Manual">Manual</option>
                  </select>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">Fuel Type</label>
                  <select
                    value={formData.fuel_type}
                    onChange={(e) => setFormData({...formData, fuel_type: e.target.value})}
                    className="w-full px-4 py-3 bg-[#0d0d0d] border border-gray-700 rounded-xl text-white focus:border-[#c9a962] transition-colors"
                  >
                    <option value="Petrol">Petrol</option>
                    <option value="CNG">CNG</option>
                    <option value="Diesel">Diesel</option>
                    <option value="Electric">Electric</option>
                    <option value="Hybrid">Hybrid</option>
                  </select>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">Seating Capacity</label>
                  <input
                    type="number"
                    min="2"
                    max="12"
                    value={formData.seating_capacity}
                    onChange={(e) => setFormData({...formData, seating_capacity: parseInt(e.target.value)})}
                    className="w-full px-4 py-3 bg-[#0d0d0d] border border-gray-700 rounded-xl text-white focus:border-[#c9a962] transition-colors"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">Price Per Day (₹)</label>
                  <input
                    type="number"
                    min="0"
                    value={formData.price_per_day}
                    onChange={(e) => setFormData({...formData, price_per_day: e.target.value})}
                    className="w-full px-4 py-3 bg-[#0d0d0d] border border-gray-700 rounded-xl text-white focus:border-[#c9a962] transition-colors"
                    required
                  />
                </div>
                
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-300 mb-2">Location</label>
                  <input
                    type="text"
                    value={formData.location}
                    onChange={(e) => setFormData({...formData, location: e.target.value})}
                    className="w-full px-4 py-3 bg-[#0d0d0d] border border-gray-700 rounded-xl text-white focus:border-[#c9a962] transition-colors"
                  />
                </div>
                
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-300 mb-2">Description</label>
                  <textarea
                    rows="3"
                    value={formData.description}
                    onChange={(e) => setFormData({...formData, description: e.target.value})}
                    className="w-full px-4 py-3 bg-[#0d0d0d] border border-gray-700 rounded-xl text-white focus:border-[#c9a962] transition-colors"
                  />
                </div>
                
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-300 mb-2">Features (comma separated)</label>
                  <input
                    type="text"
                    value={formData.features}
                    onChange={(e) => setFormData({...formData, features: e.target.value})}
                    placeholder="Sunroof, ABS, Airbags, Leather Seats"
                    className="w-full px-4 py-3 bg-[#0d0d0d] border border-gray-700 rounded-xl text-white focus:border-[#c9a962] transition-colors"
                  />
                </div>
                
                <div className="md:col-span-2">
                  <label className="flex items-center gap-3 cursor-pointer p-3 bg-gray-800/50 rounded-xl">
                    <input
                      type="checkbox"
                      checked={formData.is_featured === 1}
                      onChange={(e) => setFormData({...formData, is_featured: e.target.checked ? 1 : 0})}
                      className="w-5 h-5 rounded border-gray-600 bg-[#0d0d0d] text-[#c9a962] focus:ring-[#c9a962]"
                    />
                    <span className="text-white font-medium">Mark as Featured Car</span>
                  </label>
                </div>
              </div>
              
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 pt-5 border-t border-gray-800">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="px-6 py-3 bg-gray-800 text-white rounded-xl hover:bg-gray-700 transition-colors font-medium"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="flex-1 px-6 py-3 bg-gradient-to-r from-[#c9a962] to-[#a08040] text-black font-semibold rounded-xl hover:shadow-xl hover:shadow-[#c9a962]/30 transition-all"
                >
                  {editingCar ? 'Update Car' : 'Add Car'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      
      {/* Message View Modal - Amazing Design */}
      {showMessageModal && selectedMessage && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0d0d0d] rounded-3xl w-full max-w-lg border border-gray-800 max-h-[90vh] overflow-y-auto shadow-2xl">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-5 lg:p-6 border-b border-gray-800 bg-gradient-to-r from-[#0d0d0d] to-[#1a1a1a] rounded-t-3xl">
              <div className="flex items-center gap-3">
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-xl font-bold shadow-lg ${!selectedMessage.is_read ? 'bg-gradient-to-br from-[#c9a962] to-[#a08040] text-black' : 'bg-gray-800 text-gray-400'}`}>
                  {selectedMessage.name?.[0]?.toUpperCase()}
                </div>
                <div>
                  <h2 className="text-lg font-bold text-white">{selectedMessage.name}</h2>
                  <p className="text-[#c9a962] text-sm">{selectedMessage.phone}</p>
                </div>
              </div>
              <button onClick={() => setShowMessageModal(false)} className="text-gray-400 hover:text-white p-2 hover:bg-gray-800 rounded-xl transition-colors">
                <Icons.Close />
              </button>
            </div>
            
            {/* Modal Content */}
            <div className="p-5 lg:p-6 space-y-4">
              {/* Status Badge */}
              <div className="flex items-center justify-between">
                <span className="text-gray-500 text-sm">Status</span>
                {!selectedMessage.is_read ? (
                  <span className="px-3 py-1.5 bg-gradient-to-r from-blue-500/20 to-blue-600/10 text-blue-400 text-sm rounded-full flex items-center gap-2 border border-blue-500/30">
                    <span className="w-2 h-2 bg-blue-400 rounded-full animate-pulse"></span>
                    New Message
                  </span>
                ) : (
                  <span className="px-3 py-1.5 bg-gray-500/20 text-gray-400 text-sm rounded-full border border-gray-500/30">
                    Read
                  </span>
                )}
              </div>
              
              {/* Message Content */}
              <div className="bg-gradient-to-br from-[#0d0d0d] to-[#1a1a1a] rounded-2xl p-4 lg:p-5 border border-gray-800">
                <div className="flex items-center gap-2 mb-3 text-gray-500 text-sm">
                  <Icons.Message />
                  <span>Message</span>
                </div>
                <p className="text-white whitespace-pre-wrap text-base leading-relaxed">{selectedMessage.message}</p>
              </div>
              
              {/* Date */}
              <div className="flex items-center gap-2 text-gray-500 text-sm">
                <Icons.Calendar />
                <span>Received: {formatDate(selectedMessage.created_at)}</span>
              </div>
              
              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 pt-4 border-t border-gray-800">
                <a
                  href={`tel:${selectedMessage.phone}`}
                  className="flex-1 flex items-center justify-center gap-2 px-4 lg:px-6 py-3 bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold rounded-xl hover:shadow-xl hover:shadow-green-500/30 transition-all text-sm lg:text-base"
                >
                  <Icons.Phone />
                  Call Now
                </a>
                <button
                  onClick={() => setShowMessageModal(false)}
                  className="flex-1 px-4 lg:px-6 py-3 bg-gray-800 text-white font-semibold rounded-xl hover:bg-gray-700 transition-colors text-sm lg:text-base"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminDashboard;
